/* assets/mos-stock-gauge.js — one honest stock line on product cards.
 *
 * HISTORY, because the first version was wrong and the reason matters.
 *
 * v1 drew five coloured ticks on each card, one per state, plus the label of the BEST state.
 * Measured against the real feed, that was misleading rather than merely busy:
 *
 *     when the badge said "In Stock", 3+ of the 5 states did not have it   82% of the time
 *     when it said "In Stock", only ONE state had it                       59% of the time
 *
 * So it told a Melbourne buyer "In Stock" when only Perth held any. The word answered "is it
 * anywhere in Australia" while the ticks answered "is it in each state", and putting them side
 * by side implied they agreed. It also rendered nothing at all for the 42% of the catalogue with
 * no supplier feed, and wrapped onto a second line only on cards whose price text was long — so
 * rows came out ragged and Add to Cart buttons stopped lining up.
 *
 * v2: ONE dot and one phrase, derived from all five states, on its own line on every card.
 *
 *     In stock            any one state over 50 units, OR two or more states with 11+
 *     Low stock           some stock, but thinner than that
 *     On backorder        all five states known and at zero
 *     Check availability  no supplier feeds us this product
 *
 * The middle rule is the important one: the feed stores bands, not counts, and 40 units in each
 * of three warehouses is genuinely well stocked while landing in the middle band everywhere. A
 * naive "level 3 in most states" rule called half the catalogue Low stock. Against the live feed
 * the rule above splits the 17,549 products with data 52 / 42 / 6.
 *
 * "Check availability" is deliberate rather than blank: for those 12,453 products the honest
 * answer is that we do not know, and asking is exactly the action this store wants — it has a
 * quote flow. It also keeps every card the same height, which is what makes a row line up.
 *
 * Per-state detail is not lost: it is in the hover title here, and in full on the product page,
 * where the panel has room to be accurate.
 *
 * Bands and state order are still copied from pdp-stock.js and must stay copied:
 *   <=0 Restocking / <=10 Last Few / <=50 Low Stock / >50 In Stock, order QLD NSW VIC WA SA.
 * mos-card-stock.json is generated with those bands already applied (including the pack divisor
 * from itf-packs.json), so a card can never disagree with the panel one click later.
 */
(function () {
  'use strict';

  if (window.__mosStockGauge) return;

  var CFG = window.mosStockGaugeConfig || {};
  var API = (window.__mosStockGauge = {
    version: 2,
    state: 'idle',
    handles: 0,
    marked: 0,
    counts: { in: 0, low: 0, back: 0, unknown: 0 },
    lastError: null,
    source: null
  });

  if (CFG.enabled === false) { API.state = 'off'; return; }

  var STATES = ['QLD', 'NSW', 'VIC', 'WA', 'SA'];
  // Only used for the hover detail, which is the one place per-state wording is still honest.
  var TICK = ['Restocking', 'Last Few', 'Low Stock', 'In Stock'];

  var STATUS = {
    in:      { cls: 'in',      color: CFG.colorIn      || '#319F0C', label: CFG.labelIn      || 'In stock' },
    low:     { cls: 'low',     color: CFG.colorLow     || '#CE5F13', label: CFG.labelLow     || 'Low stock' },
    back:    { cls: 'back',    color: CFG.colorBack    || '#9F0C0C', label: CFG.labelBack    || 'On backorder' },
    unknown: { cls: 'unknown', color: CFG.colorUnknown || '#8A8A8A', label: CFG.labelUnknown || 'Check availability' }
  };

  var DATA = null;

  /* ---------------------------------------------------------------- data */

  /* Split levels (added 22 Sep 2026). The stock refresh also publishes these levels cut into
   * stamp.cn pieces, itf-cardx-000..127.json, keyed by an FNV-1a hash of the handle, and writes
   * the build they came from into stamp.cv. The homepage's 12 cards then need ~11 small pieces
   * (~43KB) instead of the whole feed (~277KB). ANY doubt - no cv in the stamp, a piece that
   * fails, a piece from another build - falls back to the full CFG.url file, exactly as before.
   * Levels in the pieces are built with the card task's own rules (proven identical on all
   * 19,932 handles), so a card reads the same either way. */
  var STAMP_URL = '/cdn/shop/files/itf-stamp.json';
  var PIECE_URL = '/cdn/shop/files/itf-cardx-';
  var SPLIT = null;

  function pieceOf(h) {
    for (var x = 2166136261, i = 0; i < h.length; i++) {
      x ^= h.charCodeAt(i);
      x = Math.imul(x, 16777619) >>> 0;
    }
    return ((x ^ (x >>> 16)) >>> 0) % SPLIT.n;
  }

  function needPiece(i) {
    if (SPLIT.loaded[i] || SPLIT.q[i]) return;
    SPLIT.q[i] = true;
    var pad = i < 10 ? '00' : i < 100 ? '0' : '';
    fetch(PIECE_URL + pad + i + '.json?v=' + encodeURIComponent(SPLIT.t), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        if (!SPLIT) return;
        if (!d || d.v !== SPLIT.v || d.n !== SPLIT.n || !d.s) throw new Error('build');
        for (var k in d.s) DATA[k] = d.s[k];
        if (d.built && API.source) API.source.built = d.built;
        SPLIT.loaded[i] = true;
        API.handles = Object.keys(DATA).length;
        schedule();
      })
      .catch(function (e) {
        // One bad piece and we stop trusting the split for this page view.
        if (!SPLIT) return;
        API.lastError = 'split: ' + String(e);
        SPLIT = null;
        API.mode = 'full';
        DATA = null;
        API.state = 'idle';
        loadFull();
      });
  }

  function load() {
    if (API.state !== 'idle') return;
    API.state = 'loading';
    // Minute-granular key: the CDN answers from cache, the stamp is at most a minute stale.
    fetch(STAMP_URL + '?v=' + Math.floor(Date.now() / 60000), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (st) {
        if (st && typeof st.cv === 'string' && st.cv && st.cn > 0 && st.cn < 4096) {
          SPLIT = { n: st.cn | 0, v: st.cv, t: st.v || st.cv, loaded: {}, q: {} };
          DATA = {};
          API.mode = 'split';
          API.source = { v: st.cv, built: '' };
          API.state = 'ready';
          sweep();
        } else {
          API.state = 'idle';
          loadFull();
        }
      });
  }

  function loadFull() {
    if (API.state !== 'idle') return;
    if (!CFG.url) { API.state = 'no-url'; return; }
    API.state = 'loading';
    API.mode = 'full';
    fetch(CFG.url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.s) { API.state = 'empty'; return; }
        DATA = d.s;
        if (Array.isArray(d.states) && d.states.length === 5) STATES = d.states;
        API.handles = Object.keys(DATA).length;
        API.source = d.source || null;
        API.state = 'ready';
        sweep();
      })
      .catch(function (e) { API.state = 'error'; API.lastError = String(e); });
  }

  /* ------------------------------------------------------------- classify */

  function classify(levels) {
    var over50 = 0, eleven_plus = 0, any = 0;
    for (var i = 0; i < 5; i++) {
      var n = parseInt(levels.charAt(i), 10);
      if (!isFinite(n)) n = 0;
      if (n === 3) over50++;
      if (n >= 2) eleven_plus++;
      if (n >= 1) any++;
    }
    if (over50 >= 1 || eleven_plus >= 2) return 'in';
    if (any > 0) return 'low';
    return 'back';
  }

  function tipFor(levels) {
    var out = [];
    for (var i = 0; i < 5; i++) {
      var n = parseInt(levels.charAt(i), 10);
      if (!isFinite(n) || n < 0 || n > 3) n = 0;
      out.push(STATES[i] + ' ' + TICK[n]);
    }
    return out.join('  ·  ');
  }

  /* --------------------------------------------------------------- helpers */

  function handleFrom(root) {
    var a = root.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  // Capped walk so a card with no link of its own cannot climb out and adopt a neighbour's.
  function cardFor(priceEl) {
    var e = priceEl;
    for (var i = 0; i < 6 && e; i++) {
      if (e.querySelector && e.querySelector('a[href*="/products/"]')) return e;
      e = e.parentElement;
    }
    return null;
  }

  function build(key, levels) {
    var st = STATUS[key];
    var wrap = document.createElement('span');
    wrap.className = 'mos-sg mos-sg--' + st.cls;
    wrap.setAttribute('data-mos-sg', key);

    var dot = document.createElement('span');
    dot.className = 'mos-sg__dot';
    dot.style.background = st.color;
    wrap.appendChild(dot);

    var txt = document.createElement('span');
    txt.className = 'mos-sg__text';
    txt.style.color = st.color;
    txt.textContent = st.label;
    wrap.appendChild(txt);

    if (levels) {
      wrap.setAttribute('title', tipFor(levels) +
        (API.source && API.source.built ? '\n\nStock as at ' + API.source.built : ''));
      wrap.setAttribute('aria-label', st.label + '. By state: ' + tipFor(levels));
    } else {
      wrap.setAttribute('title', CFG.unknownTip ||
        'No supplier feeds us stock for this product. Ask us and we will check.');
      wrap.setAttribute('aria-label', st.label);
    }
    return wrap;
  }

  /* -------------------------------------------------------------- placement */

  //   the theme's own cards (search dropdown, Keep Browsing, recommendations) use .price
  //   the vendor's Preact cards (collection and search grids) use build-hashed names, read out
  //     of search-app.css's own class map rather than guessed: priceRow snSK2B2rTshsCWMccngR.
  //     If Moustache Republic rebuild, that hash changes and the vendor cards quietly stop
  //     matching. The theme cards keep working and nothing breaks.
  var PRICE_SELECTORS = (CFG.priceSelectors || '.price, .snSK2B2rTshsCWMccngR').split(',');

  // Always its own row, never trailing the RRP. Trailing it was what made rows ragged: the line
  // wrapped on cards whose price text happened to be long and not on the others, so the Add to
  // Cart buttons sat at different heights across one row.
  function slotIn(priceEl, node) {
    var row = document.createElement('div');
    row.className = 'mos-sg__row';
    row.appendChild(node);
    var dl = priceEl.querySelector('dl');
    if (dl && dl.parentNode) {
      dl.parentNode.insertBefore(row, dl.nextSibling);
    } else {
      priceEl.appendChild(row);
    }
  }

  function sweep() {
    if (API.state !== 'ready' || !DATA) return;
    var els = document.querySelectorAll(PRICE_SELECTORS.join(','));
    for (var i = 0; i < els.length; i++) {
      var priceEl = els[i];
      if (priceEl.getAttribute('data-mos-sg-done')) continue;
      var card = cardFor(priceEl);
      if (!card) continue;
      var h = handleFrom(card);
      if (SPLIT && h) {
        // Split mode: wait for this card's piece; its arrival schedules another sweep.
        var p = pieceOf(h);
        if (!SPLIT.loaded[p]) { needPiece(p); continue; }
      }
      priceEl.setAttribute('data-mos-sg-done', '1');
      API.marked++;

      var levels = h ? DATA[h] : null;
      var key;
      if (typeof levels === 'string' && levels.length >= 5) {
        key = classify(levels);
      } else {
        // Absent from the feed means nobody supplies us this product. That is a different fact
        // from "known and at zero", so it never says out of stock.
        key = 'unknown';
        levels = null;
        if (CFG.showUnknown === false) continue;
      }
      API.counts[key === 'unknown' ? 'unknown' : key]++;
      try { slotIn(priceEl, build(key, levels)); } catch (e) { API.lastError = String(e); }
    }
  }

  /* ------------------------------------------------------------------ boot */

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; try { sweep(); } catch (e) {} }, 80);
  }

  // Only count a price that sits inside a product card - the same test sweep() uses to decide
  // what to decorate. The product page's own price has no card around it, so a product page
  // with no "Often ordered together" row no longer downloads the whole feed for nothing
  // (measured 22 Sep 2026: ~93% of product pages, 277KB compressed / 1.35MB parsed each).
  function anyCards() {
    var els = document.querySelectorAll(PRICE_SELECTORS.join(','));
    for (var i = 0; i < els.length; i++) if (cardFor(els[i])) return true;
    return false;
  }

  function start() {
    // Lazy twice over: after first paint, and only when there is a card to decorate. 253KB is
    // not worth fetching on a page with no prices on it.
    var began = false;
    function maybeLoad() {
      if (began || !anyCards()) return;
      began = true;
      load();
    }
    new MutationObserver(function () { maybeLoad(); schedule(); })
      .observe(document.documentElement, { childList: true, subtree: true });
    var kick = function () { maybeLoad(); schedule(); };
    if (window.requestIdleCallback) window.requestIdleCallback(kick, { timeout: 2000 });
    else setTimeout(kick, 600);
    window.addEventListener('load', kick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
